(() => {
  "use strict";

  const popup = document.querySelector("newsletter-popup.modal--newsletter");
  const country = document.querySelector(
    '.footer__aside button[aria-controls$="-country"]'
  );
  if (!popup && !country) return;

  let api;
  let hiddenHere = false;
  let chatOpen = false;
  let frame;

  function chatIsAlreadyOpen() {
    const root = document.getElementById("tidio-chat")?.shadowRoot;
    return Boolean(root?.getElementById("button")?.classList.contains("chat-open"));
  }

  function countryIsVisible() {
    if (!country) return false;
    const rect = country.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 &&
      rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function update() {
    frame = undefined;
    if (!api) return;
    const obstructed = !chatOpen &&
      (popup?.hasAttribute("open") || countryIsVisible());

    if (obstructed && !hiddenHere) {
      const host = document.getElementById("tidio-chat");
      if (!host) return;
      const style = getComputedStyle(host);
      // Do not take ownership of a widget already hidden by the merchant/app.
      if (style.display === "none" || style.visibility === "hidden") return;
      api.hide();
      hiddenHere = true;
    } else if (!obstructed && hiddenHere) {
      api.show();
      hiddenHere = false;
    }
  }

  function schedule() {
    if (frame === undefined) frame = requestAnimationFrame(update);
  }

  function bindApi() {
    const next = window.tidioChatApi;
    if (!next || typeof next.hide !== "function" || typeof next.show !== "function") return;
    if (api === next) return schedule();
    api = next;
    chatOpen = chatIsAlreadyOpen();
    api.on("open", () => {
      chatOpen = true;
      schedule();
    });
    api.on("close", () => {
      chatOpen = false;
      schedule();
    });
    api.on("ready", () => {
      chatOpen = chatIsAlreadyOpen();
      schedule();
    });
    schedule();
  }

  if (popup) {
    new MutationObserver(schedule).observe(popup, {
      attributes: true,
      attributeFilter: ["open"],
    });
  }
  if (country) new IntersectionObserver(schedule).observe(country);
  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", schedule, { passive: true });
  window.addEventListener("pageshow", schedule);
  document.addEventListener("tidioChat-ready", bindApi);
  bindApi();
})();
